import ThemeProvider from './ThemeProvider';
import theme from './theme';

export default ThemeProvider;
export { theme };
